import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch } from "react-redux";

import { post } from "../actions/general";
import { showNotification } from "../store/notification/actions";
import messages from "./messages";

const depracateTime = 1000 * 60 * 5;

let lastTimeChecked = 0;

const NewVersionAvailable = () => {
    const dispatch = useDispatch();
    const { formatMessage } = useIntl();
    const setLastChecked = () => {
        lastTimeChecked = Date.now();
    };
    const check = () => {
        setLastChecked();
        const { BUILD_INFO } = window;
        if (!BUILD_INFO) return;
        dispatch(post("is-new-version-available", BUILD_INFO, ({ data: { isAvailable } }: { data: { isAvailable: boolean}}) => {
            if (isAvailable) {
                dispatch(showNotification(formatMessage(messages.newVersion), "reload"))
            }
        }));
    };
    useEffect(() => {
        setLastChecked();
        window.addEventListener("focus", () => {
            if (lastTimeChecked + depracateTime < Date.now()) {
                check();
            }
        });
    }, []);
    
    return null;
}

export default NewVersionAvailable;
